import React from 'react';

const ApiKeyPermissionFormModal = React.lazy(() => import('../components/FormModal'));
const apiKeyPermissionModalRegistry = {
    core_apiKeyPermissionId: ApiKeyPermissionFormModal
};
export default apiKeyPermissionModalRegistry;
